<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container ">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center mt-4" [ngClass]="{'page-title': useRebrandedLayout }">
          Gender
        </h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 text-center mt-5 mb-3">
        <h5 [ngClass]="{'page-title': useRebrandedLayout }">
          To change your gender, please fill in the field below:
        </h5>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3">

        <form
          #updateGenderForm="ngForm"
          (ngSubmit)="save(updateGenderForm)"
          novalidate>
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div
              *ngIf="existingGender"
              class="mb-3">
              <label class="form-label" for="genderCurrent">
                Current gender
              </label>
              <input
                #genderCurrent="ngModel"
                class="form-control"
                name="genderCurrent"
                [ngModel]="existingGender"
                placeholder="Current gender"
                readonly
                type="text">
            </div>

            <hr *ngIf="!useRebrandedLayout" class="my-4">

            <div>
              <label class="form-label" for="gender">
                New gender
              </label>
              <select
              #gender="ngModel"
              class="form-control form-select"
              [class.is-invalid]="gender.touched && gender.invalid"
              id="gender"
              name="gender"
              [required]="true"
              [(ngModel)]="newGender">
                <option [ngValue]="null" disabled>Please choose an option</option>
                <option *ngFor="let genderEntry of Genders" [ngValue]="genderEntry">
                  {{ genderEntry }}
                </option>
              </select>
            </div>
          </div>
          <button
            class="btn btn-success text-white btn-lg w-100 mt-5"
            [disabled]="!updateGenderForm.valid || loading"
            type="submit">
            <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
            {{ loading ? 'Saving' : 'Save' }}
          </button>

        </form>

      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a *ngIf="!redirectParams" [routerLink]="['/account']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
        </a>
        <a
          *ngIf="redirectParams"
          [routerLink]="redirectParams.l"
          [queryParams]="redirectParams.q"
          [fragment]="redirectParams.f">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back
        </a>
      </div>
    </div>
  </div>
</div>
